import React, { useContext } from "react";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import ContextComponent from "../../AppContext";
import Utils from "../../Utils";

import BackButton from "../../../assets/img/back.png";

import sectionsImg from "../../../assets/img/navitems/dark/sections.png";
import sectionsActiveImg from "../../../assets/img/navitems/light/sections.png";

import fieldsImg from "../../../assets/img/navitems/dark/fields.png";
import fieldsActiveImg from "../../../assets/img/navitems/light/fields.png";

import labelsImg from "../../../assets/img/navitems/dark/labels.png";
import labelsActiveImg from "../../../assets/img/navitems/light/labels.png";

import reportsImg from "../../../assets/img/navitems/dark/report.png";
import reportsActiveImg from "../../../assets/img/navitems/light/report.png";

const images = {
    sections: sectionsImg,
    fields: fieldsImg,
    labels: labelsImg,
    reports: reportsImg,
};

const activeImages = {
    sections: sectionsActiveImg,
    fields: fieldsActiveImg,
    labels: labelsActiveImg,
    reports: reportsActiveImg,
};

const SiteLeftNavigation = () => {

    const navigate = useNavigate();
    const { siteid } = useParams();

    let navLinkKeys = Utils.SITE_NAV_ITEMS_KEYS;
    let navLinkValues = JSON.parse(JSON.stringify(Utils.SITE_NAV_ITEMS_VALUES));

    const location = useLocation();

    const isAtRootUrl =
        location?.pathname === Utils.APP_URLS.SITE_PAGE.replace(":siteid", siteid) ||
        location?.pathname === Utils.APP_URLS.SITE_SECTIONS.replace(":siteid", siteid) || 
        location?.pathname.indexOf(Utils.APP_URLS.SITE_PAGE.replace(":siteid", siteid) + "/section/") === 0;

    navLinkKeys.forEach(navLink => {
        navLinkValues[navLink].url = navLinkValues[navLink].url.replace(":siteid", siteid);
    });

    const backToSitesPage = (e) => {
        navigate(Utils.APP_URLS.SITES_PAGE);
    };

    return (
        <>
            {(<div className="indi-left-navigation-wrapper">

                <div onClick={backToSitesPage} className="indi-navmenu-item indi-navmenu-item-back">
                    <div className="indi-navmenu-inactive">
                        <img
                            className="indi-w-32 w-20 indi-navmenu-item-back-img"
                            src={BackButton}
                            alt={"Back to sites"}
                        ></img>
                        <span className="indi-ml-1 indi-navmenu-item-back-label">Back to sites</span>
                    </div>
                </div>

                {navLinkKeys.map((navKey, index, src) => (
                    <div className="indi-navmenu-item" key={index}>
                        <NavLink
                            className={({ isActive }) => {
                                if (isAtRootUrl) {
                                    isActive = index === 0;
                                }
                                return isActive ? "indi-navmenu-active" : "indi-navmenu-inactive";
                            }}
                            to={navLinkValues[navKey].url}
                        >
                            {({ isActive }) => (
                                <>
                                    {isActive ||
                                        (isAtRootUrl && index === 0 && (isActive = true)) ? (
                                        <img
                                            className="indi-w-32 w-20"
                                            src={activeImages[navKey]}
                                            alt={navLinkValues[navKey].title}
                                        ></img>
                                    ) : (
                                        <img
                                            className="indi-w-32 w-20"
                                            src={images[navKey]}
                                            alt={navLinkValues[navKey].title}
                                        ></img>
                                    )}
                                    <span className="indi-ml-1">{navLinkValues[navKey].title}</span>
                                </>
                            )}
                        </NavLink>
                    </div>
                ))}
            </div>
            )}
        </>
    );
};

export default SiteLeftNavigation;
